import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

export const MultiSelect = ({ options, value, onChange, placeholder }) => (
  <Select
    isMulti
    classNamePrefix="react-select"
    onChange={onChange}
    options={options}
    value={value}
    placeholder={placeholder}
    classNames={{
      control: () => 'form-select',
      dropdownIndicator: () => 'd-none',
      clearIndicator: () => 'cursor-pointer',
      input: () => 'p-0',
      valueContainer: () => 'p-0'
    }}
    noOptionsMessage={() => 'No hay opciones'}
  />
);
MultiSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  value: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired
};
